import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

type DogCardProps = {
  src: string;
  title: string;
};

export const DogCard = ({ src, title }: DogCardProps) => {
  return (
    <Card
      sx={{
        maxWidth: { xs: "100%", sm: 345 },
        borderRadius: 2,
        backgroundColor: "rgba(255,255,255,0.8)",
        border: "1px solid #d4c4a8",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <CardMedia
        sx={{
          height: 220,
          backgroundColor: "#d4b483",
          ...(!src && {
            backgroundSize: "75%",
            backgroundPosition: "center",
          }),
        }}
        image={src || "/images/no_photo.png"}
        title={title}
      />
      <CardContent sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontFamily: '"Cinzel", serif',
            color: "#4a3728",
            fontSize: "1rem",
            lineHeight: 1.3,
            minHeight: "2.6em",
          }}
        >
          {title}
        </Typography>
      </CardContent>
    </Card>
  );
};
